import {IComponentOptions, IFilterService, ILogService, IPromise} from 'angular';
import moment from 'moment';
import {beitragArtPrefix, getTSBeitragArtValues, TSBeitragArt} from '../../../models/enums/TSBeitragArt';
import TSBeitraegeSearchresultDTO from '../../../models/TSBeitraegeSearchresultDTO';
import TSBeitrag from '../../../models/TSBeitrag';
import TSBeitragDTO from '../../../models/TSBeitragDTO';
import TSBeitragPreFilterDTO from '../../../models/TSBeitragPreFilterDTO';
import {RemoveDialogController} from '../../dialog/RemoveDialogController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import ErrorService from '../../errors/service/ErrorService';
import BeitragRS from '../../service/BeitragRS';
import IFormController = angular.IFormController;
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-zahlungen-list.html');
require('./dv-zahlungen-list.scss');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVZahlungenListConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        onEdit: '&',
        onEditBeitrag: '&',
        onFilterChange: '&',
        prefilter: '=',
        tabindex: '@',
        selectedtab: '=',
        freigebenMode: '<', //modus
        ausfuehrenMode: '<'
    };
    template = template;
    controller = DVZahlungenListController;
    controllerAs = 'vm';
}

export class DVZahlungenListController {
    form: IFormController;
    prefilter: TSBeitragPreFilterDTO;
    freigebenMode: boolean;
    ausfuehrenMode: boolean;

    displayedCollection: Array<TSBeitragDTO> = []; //Liste die im Gui angezeigt wird
    pagination: any;

    selectedStatus: string;
    alleCheckbox: boolean;

    onFilterChange: (changedTableState: any) => IPromise<any>;
    onEdit: (paramObj: any) => void;
    onEditBeitrag: (paramObj: any) => void;

    nichtZugeteiltMarker = 'NICHT_ZUGETEILT';
    tableFilterState: any;

    datumFaellig: moment.Moment | undefined;

    tabindex: string;
    selectedtab: number; // indexID der aktuellen Schadenfalltabelle (es gibt mehrere)
    defaultTableFilterState: any = {
        sort: {},
        search: {},
        pagination: {start: 0, totalItemCount: 0, number: 30}
    };

    checklistEntries: Array<string> = ['CHECK_AUSZAHLUNG_1', 'CHECK_AUSZAHLUNG_2', 'CHECK_AUSZAHLUNG_3'];
    checklistValid: boolean;
    ref: string | undefined;
    allChecked: boolean = false;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', '$window', '$translate', 'BeitragRS', 'DvDialog', 'ErrorService'];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private $window: IWindowService,
                private $translate: ITranslateService, private beitragRS: BeitragRS, private dvDialog: DvDialog,
                private errorService: ErrorService) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {
    }

    editClicked(beitragDTO: any, event: any) {
        this.onEdit({beitragDTO: beitragDTO, event: event});
    }

    editClickedBeitrag(beitragDTO: TSBeitragDTO, beitrag: TSBeitrag, event: any) {
        if (angular.isFunction(this.onEditBeitrag)) {
            this.onEditBeitrag({beitragDTO: beitragDTO, beitrag: beitrag, event: event})
        }

    }

    private callServer = (tableFilterState: any) => {
        this.tableFilterState = tableFilterState;
        //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
        if (this.selectedtab !== parseInt(this.tabindex)) {
            return;
        }

        this.pagination = tableFilterState.pagination;

        if (this.onFilterChange && angular.isFunction(this.onFilterChange)) {
            this.onFilterChange({
                tableState: tableFilterState,
                prefilter: this.prefilter
            }).then((result: TSBeitraegeSearchresultDTO) => {
                if (result) {
                    tableFilterState.pagination.totalItemCount = result.totalResultSize;
                    tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                    this.displayedCollection = new Array<TSBeitragDTO>().concat(result.schadenfallBeitragDTOs);
                    this.alleCheckbox = false;
                }
            });
        } else {
            this.$log.info('no callback function spcified for filtering');
        }
    };

    /**
     * Alle TSZahlungenStatus fuer das Filterdropdown
     * @returns {Array<TSBeitragArt>}
     */
    public getTSBeitragArtValues(): Array<TSBeitragArt> {
        return getTSBeitragArtValues();
    }

    public getColumnsNumber(): number {
        let element = angular.element('.dv-zahlungen-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 8;
    }

    public getClass(): string {
        return 'tab-nr-' + this.tabindex;
    }

    public alleChanged() {
        this.displayedCollection.forEach((schadenfallBeitragDTO) => {
            schadenfallBeitragDTO.beitraege.forEach((beitrag) => {
                beitrag.selected = this.alleCheckbox;
            });
        });
    }

    public doFreigeben() {
        let ids: Array<string> = this.getSelectedIds();
        if (ids.length > 0) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
                text: '',
                title: this.$translate.instant('FREIGEBEN_DIALOG', {anzahl: ids.length})
            }).then(() => {   //User confirmed chage of state
                this.beitragRS.beitraegeFreigeben(ids).then(() => {
                    //success --> reload table
                    this.errorService.clearAll();
                    this.callServer(this.tableFilterState);
                });
            }).catch(() => {
            });
        } else {
            this.errorService.addMesageAsError('ERROR_NO_BEITRAEGE');
            this.$log.debug('Form was not valid');
        }

    }

    private getSelectedIds(): Array<string> {
        let ids: Array<string> = [];
        this.displayedCollection.forEach((schadenfallBeitragDTO) => {
            schadenfallBeitragDTO.beitraege.forEach((beitrag) => {
                if (beitrag.selected) {
                    ids.push(beitrag.id)
                }
            });
        });
        return ids;
    }

    public doAusfuehren() {
        if (this.disabledAusfuehren()) {
            this.$log.error('Checklist not valid or ref undefined');
            return;
        }
        let ids: Array<string> = this.getSelectedIds();
        if (ids.length > 0) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
                text: '',
                title: this.$translate.instant('AUSFUEHREN_DIALOG', {anzahl: ids.length})
            }).then(() => {   //User confirmed chage of state
                if (this.ref && this.datumFaellig) {
                    this.beitragRS.beitraegeAusfuehren(ids, this.ref, this.datumFaellig).then(() => {
                        this.ref = undefined;
                        this.datumFaellig = undefined;
                        this.allChecked = false;
                        this.form.$setPristine();
                        this.form.$setUntouched();
                        this.errorService.clearAll();
                        this.callServer(this.tableFilterState);
                    });
                } else {
                    this.$log.warn('ref and datumFaellig are not set, do nothing')
                }
            }).catch(() => {
            });
        } else {
            this.errorService.addMesageAsError('ERROR_NO_BEITRAEGE');
            this.$log.debug('Form was not valid');
        }
    }

    public getChecklistEntries(): Array<string> {
        return this.checklistEntries;
    }

    public checklistStatusChanged(allchecked: boolean): void {
        this.checklistValid = allchecked;
    }

    public disabledAusfuehren(): boolean {
        return !this.checklistValid || this.ref === undefined || this.datumFaellig === undefined;
    }

    public getTSBeitragArtTranslate(beitragArt: TSBeitragArt): string {
        let prefix = beitragArtPrefix();
        return this.$translate.instant(prefix + TSBeitragArt[beitragArt])
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-zahlungen-list/dv-zahlungen-list.ts